"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const AssignmentsContext_1 = require("../../../assignment/AssignmentsContext");
const DispatchContext_1 = require("../../../context/DispatchContext");
const Modal_1 = require("../../../elements/popup/Modal");
const options_1 = require("../../../elements/popup/options");
const EditRangeModal_1 = __importDefault(require("../../../modal/editRange/EditRangeModal"));
function useEditRangeModal(range) {
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const modal = (0, Modal_1.useModal)();
    const assignmentData = (0, AssignmentsContext_1.useAssignmentData)();
    const zoomRange = (0, react_1.useCallback)((modalRange) => {
        const _range = modalRange || range;
        if (_range) {
            const { from, to } = _range;
            const margin = Math.abs(from - to);
            dispatch({
                type: 'SET_X_DOMAIN',
                payload: {
                    xDomain: [from - margin, to + margin],
                },
            });
        }
    }, [dispatch, range]);
    const deleteRange = (0, react_1.useCallback)((id, resetSelectTool = false) => {
        if (range || id) {
            dispatch({
                type: 'DELETE_RANGE',
                payload: {
                    id: id || range?.id,
                    assignmentData,
                    resetSelectTool,
                },
            });
        }
    }, [assignmentData, dispatch, range]);
    const changeRangeSignalKind = (0, react_1.useCallback)((kind) => {
        if (range) {
            dispatch({
                type: 'CHANGE_RANGE_SIGNAL_KIND',
                payload: {
                    range,
                    kind,
                },
            });
        }
    }, [dispatch, range]);
    const saveEditRangeHandler = (0, react_1.useCallback)((editedRange, automaticCloseModal = true) => {
        dispatch({
            type: 'SAVE_EDITED_RANGE',
            payload: {
                range: editedRange,
                assignmentData,
            },
        });
        if (automaticCloseModal) {
            modal.close();
        }
    }, [assignmentData, dispatch, modal]);
    const resetHandler = (0, react_1.useCallback)((originalRange) => {
        saveEditRangeHandler(originalRange, false);
        modal.close();
    }, [modal, saveEditRangeHandler]);
    const editRange = (0, react_1.useCallback)(() => {
        if (!range?.id)
            return;
        dispatch({
            type: 'SET_SELECTED_TOOL',
            payload: { selectedTool: 'editRange' },
        });
        modal.show((0, jsx_runtime_1.jsx)(EditRangeModal_1.default, { onRest: resetHandler, onSave: saveEditRangeHandler, onZoom: zoomRange, rangeId: range?.id }), {
            position: options_1.positions.MIDDLE_RIGHT,
            transition: options_1.transitions.SCALE,
            isBackgroundBlur: false,
        });
        zoomRange();
    }, [
        dispatch,
        modal,
        range?.id,
        resetHandler,
        saveEditRangeHandler,
        zoomRange,
    ]);
    return (0, react_1.useMemo)(() => ({
        editRange,
        deleteRange,
        zoomRange,
        changeRangeSignalKind,
    }), [changeRangeSignalKind, deleteRange, editRange, zoomRange]);
}
exports.default = useEditRangeModal;
